export default "__VITE_ASSET__DsGi$WME__"